export const experienceData = [
    {
        id: 1,
        company: 'Cognizant Technology Solutions',
        jobtitle: 'Full Stack Dev',
        startYear: 'Dec 2023',
        endYear: 'Present',
        summary: 'Architected cloud-to-cloud replatforming, modernized legacy applications into serverless and microservices-based solutions, and led secure API and Angular UI delivery on Azure and AWS.'
    },
    {
        id: 2,
        company: 'Tata Consultancy Services',
        jobtitle: 'Full Stack',
        startYear: 'Jan 2019',
        endYear: 'Dec 2023',
        summary: 'Delivered full-stack features for a telecom infrastructure portal, built Java/Spring Boot backend services, and migrated monolithic modules toward hybrid-cloud-ready microservices.'
    },
    {
        id: 3,
        company: 'Wipro Technologies',
        jobtitle: 'Engineer',
        startYear: 'Nov 2016',
        endYear: 'Dec 2018',
        summary: 'Worked in Agile sprint cycles for automotive logistics portals, implemented Spring MVC backends, DAO layers, and JSP/HTML/JS UI modules.'
    },
]